import * as React from 'react';
import { logout, getUserApi } from '../api/api';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/use-user-store';
import useGetRole, { getRoleName } from '../hooks/use-role';
import AccountVerification from '../features/user/AccountVerification';
import LogoutIcon from '@mui/icons-material/Logout';
import EditSettingsForm from '../features/user/EditSettingsForm';
import InfoIcon from '@mui/icons-material/Info';
import { useState } from 'react';
import Tooltip from '../components/Tooltip';

const User = () => {
  const { user, setUser, setAuthorized } = useUserStore();
  const { isEngineer } = useGetRole();
  const [showStatusModal, setShowStatusModal] = useState(false);

  const navigate = useNavigate();
  const out = async () => {
    await logout();
    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
      },
      function (err) {
        setAuthorized(false);
      }
    );
    navigate('/');
  };

  const data = [
    { title: `${isEngineer ? 'Логин' : 'Название компании'}`, value: user?.username ?? '-' },
    { title: 'Номер телефона', value: user?.phone ?? '-' },
    { title: 'Электронная почта', value: user?.email ?? '-' },
    { title: 'ИНН', value: user?.inn },
    { title: 'Роль', value: getRoleName(user?.role) },
    { title: 'Статус', value: user?.verified_at ? 'Подтвержден' : 'Не подтвержден', hasIcon: !user.verified_at, handlePress: () => setShowStatusModal(true) },
    { title: 'Версия web', value: `${process.env.REACT_APP_VER} (${process.env.REACT_APP_MODE})` },
  ];

  return (
    <div className="flex w-full min-h-screen p-4 items-start justify-center bg-gray-100">
      <div className="relative bg-white shadow-2xl rounded-3xl px-8 py-6 mb-4 w-full max-w-lg">
        {!isEngineer && <EditSettingsForm />}

        <AccountVerification showModal={showStatusModal} setShowModal={setShowStatusModal} />

        <table className="table-auto w-full text-base my-4">
          <tbody>
            {data.map((item) => {
              return (
                item.value && (
                  <tr key={item.title} className="md:table-row flex flex-col md:border-b">
                    <td className="px-2 py-0.5 sm:table-cell font-semibold">{item.title}:</td>
                    <td className="px-2 py-0.5 sm:table-cell flex items-center gap-x-2 break-all">
                      <div className="flex items-center gap-x-2 justify-start">
                        <span>{item.value}</span>
                        {item?.hasIcon && item.handlePress && (
                          <Tooltip className={'text-black'} text="Нажмите для подтверждения аккаунта">
                            <button onClick={item.handlePress}>
                              <InfoIcon className="text-orange-500 hover:text-orange-600 transition-colors" />
                            </button>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
        <button onClick={out} className={'flex justify-center items-center text-red-500 gap-x-2 hover:bg-red-100 transition-colors rounded-xl px-2 py-1.5'}>
          <LogoutIcon />
          Выход
        </button>
      </div>
    </div>
  );
};
export default User;
